import { useCallback } from 'react';
import { useInterval } from 'react-use';
import { DEFAULT_UPDATE_INTERVAL_MS } from '@/config/constants';
import * as safeStorage from '@/util/safe-storage';
import { getTimestamp } from '@/util/utils';
import { actKey } from './useActivityTracker';
import { useSocket } from './useSocket';
/**
 * Hook responsible for sending the user's activity information to the server.
 *
 * The hook checks the user's last activity timestamp stored in local storage at regular
 * intervals. If it determines that there has been activity since the last update sent
 * to the server, it will send the updated activity timestamp to the server.
 *
 */
export const useServerActivityTracker = (integrationId, interval = DEFAULT_UPDATE_INTERVAL_MS) => {
    const { sendVisitorActivity } = useSocket();
    const activityKey = actKey(integrationId);
    const updateKey = `${activityKey}_server_update`;
    const checkAndUpdateServer = useCallback(() => {
        const lastActivity = parseInt(safeStorage.getItem(activityKey) || '0', 10);
        const lastUpdate = parseInt(safeStorage.getItem(updateKey) || '0', 10);
        const nextUpdate = lastUpdate + interval * 0.6; // 60% of the interval
        if (!lastActivity) {
            return;
        }
        if (lastActivity > nextUpdate) {
            safeStorage.setItem(updateKey, getTimestamp().toString());
            sendVisitorActivity(lastActivity);
        }
    }, [activityKey, updateKey, interval, sendVisitorActivity]);
    useInterval(checkAndUpdateServer, interval);
};
